import { render } from "./InfoLinks.vue?vue&type=template&id=41985890&scoped=true"
import script from "./InfoLinks.vue?vue&type=script&lang=js"
export * from "./InfoLinks.vue?vue&type=script&lang=js"

import "./InfoLinks.vue?vue&type=style&index=0&id=41985890&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41985890"]])

export default __exports__